import { useMemo } from 'react';
import EntExpenseInfo from '@/components/Approval/@components/EntExpense';
import { parseEntExpenseAttributes } from '@/utils/approval/entExpense';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

const EntExpenseSlot = ({ data }: ContentExtraProps) => {
  const saved = useMemo(
    () => parseEntExpenseAttributes(data.attributes),
    [data.attributes],
  );
  if (!saved) return null;
  return (
    <ContentSlotRoot>
      <EntExpenseInfo data={saved} />
    </ContentSlotRoot>
  );
};

export default EntExpenseSlot;
